<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 my-5">
            <div class="card border-left-danger shadow h-100">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">You are not authorized to access this page</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>